import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";

import ContactAndSafetyInfo from "../contactAndSafetyInfo";
import { TextAlignProps } from "../contactAndSafetyInfo/types";
import { AuthContext } from "src/context/authContext";
import { HCPUserSubHeaderProps } from "src/types/users";



const AuthSubHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { sub_header, isUserAuthorized } = useContext(AuthContext);
  return (
    <div className="row align-items-center">
      {isUserAuthorized &&
        <>
          <div className="col-12 col-md-5">
            <p className="mb-0 fw-bold">Sales Rep:</p>
            {sub_header &&
              sub_header.length > 0 &&
              (sub_header as HCPUserSubHeaderProps[]).map((rep, index) => (
                  <p className="mb-0">
                      <span>{rep.Rep} - </span>
                      <a href={`mailto:${rep.Email}`}>{rep.Email}</a>
                      <span> - ({Array.isArray(rep.Drugs) ? rep.Drugs.join(", ") : rep.Drugs})</span>
                  </p>
              ))}
          </div>
          <div className="col-12 col-md-3 py-2">
            <button className="btn btn-primary text-nowrap" onClick={() => navigate(`/rep_visits/new`)}>
                Schedule a Sales Rep Visit
            </button>
          </div>
        </>
      }
      <div className="col-12 col-md-4">
        <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} />
      </div>
    </div>
  );
};

export default AuthSubHeader;
